import { InstallPermissionAccessTypes } from '../constants/installPermissions';
const PERMISSION_LEVELS = {
  [InstallPermissionAccessTypes.EVERYONE]: 3,
  [InstallPermissionAccessTypes.SPECIFIC_USERS_AND_TEAMS]: 2,
  [InstallPermissionAccessTypes.SUPER_ADMINS_AND_AUTHORIZED_INSTALLERS]: 1
};
export function isPermissionDowngrade(currentState, newState) {
  const currentLevel = PERMISSION_LEVELS[currentState];
  const newLevel = PERMISSION_LEVELS[newState];
  if (currentLevel === undefined || newLevel === undefined) {
    return false;
  }
  return newLevel < currentLevel;
}
export function calculateImpactedUsersCount({
  currentState,
  newState,
  installedUsers,
  selectedUserIds,
  superAdmins,
  authorizedInstallers
}) {
  if (!isPermissionDowngrade(currentState, newState)) {
    return 0;
  }
  const usersWithAccessAfterChange = new Set();
  switch (newState) {
    case InstallPermissionAccessTypes.SUPER_ADMINS_AND_AUTHORIZED_INSTALLERS:
      Object.keys(superAdmins).forEach(id => usersWithAccessAfterChange.add(Number(id)));
      Object.keys(authorizedInstallers).forEach(id => usersWithAccessAfterChange.add(Number(id)));
      break;
    case InstallPermissionAccessTypes.SPECIFIC_USERS_AND_TEAMS:
      // Admins and authorized installers still have access
      Object.keys(superAdmins).forEach(id => usersWithAccessAfterChange.add(Number(id)));
      Object.keys(authorizedInstallers).forEach(id => usersWithAccessAfterChange.add(Number(id)));
      // Plus the selected users (teams are not expanded to their members - only individual users are tracked here)
      selectedUserIds.forEach(entity => {
        if (entity.entityType === 'USER') {
          usersWithAccessAfterChange.add(entity.entityId);
        }
      });
      break;
    case InstallPermissionAccessTypes.EVERYONE:
    default:
      return 0;
  }
  return installedUsers.filter(user => !usersWithAccessAfterChange.has(user.userId)).length;
}